@if(calledFrom != 'Recommend-list') {
<app-hire-candidate-contact-view [candidateDetails]="candidate" (handleOutputEvent)="candidateUpdated.emit($event.data)" [calledFrom]="calledFrom"></app-hire-candidate-contact-view>

}
<hr class="collapse-separator">
<!-- this section will show in pipeline listing view ..when ready uncomment it -->
<app-hire-notes [candidateDetails]="candidate" [calledFrom]="calledFrom" (notesUpdated)="candidateUpdated.emit($event)"></app-hire-notes>
<hr class="collapse-separator">
@if(calledFrom == 'pipeline-list') {
<app-hire-files [candidateId]="candidate?.basicdetails?.candidatenumber" [calledFrom]="calledFrom" (filesUpdated)="candidateUpdated.emit($event)"></app-hire-files>
}
